/* tslint:disable */
/* eslint-disable */
/**
 * Pitango Market API
 * Canonical public and administrative HTTP API contract.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    ApiErrorEnvelope,
    UsersPayloadIForgotPasswordRequest,
    UsersPayloadILoginRequest,
    UsersPayloadIRegisterRequest,
    UsersPayloadIResendConfirmationRequest,
    UsersPayloadIResetPasswordRequest,
    UsersPayloadIUpdateOrderChangePolicyRequest,
    UsersPayloadIUpdatePreferencesRequest,
    UsersPayloadIUserSetupRequest,
    UsersResponseAuthResponse,
    UsersResponseConfirmEmailResponse,
    UsersResponseForgotPasswordResponse,
    UsersResponseGetOrderChangePolicyResponse,
    UsersResponseLoginResponse,
    UsersResponseRegisterResponse,
    UsersResponseResendConfirmationResponse,
    UsersResponseResetPasswordResponse,
    UsersResponseUpdateOrderChangePolicyResponse,
    UsersResponseUpdatePreferencesResponse,
    UsersResponseUserSetupResponse,
} from '../models/index';

export interface ForgotPasswordRequest {
    usersPayloadIForgotPasswordRequest: UsersPayloadIForgotPasswordRequest;
}

export interface LoginUserRequest {
    usersPayloadILoginRequest: UsersPayloadILoginRequest;
}

export interface ResendConfirmationRequest {
    usersPayloadIResendConfirmationRequest: UsersPayloadIResendConfirmationRequest;
}

export interface UsersConfirmEmailRequest {
    token: string;
}

export interface UsersRegisterRequest {
    usersPayloadIRegisterRequest: UsersPayloadIRegisterRequest;
}

export interface UsersResetPasswordRequest {
    usersPayloadIResetPasswordRequest: UsersPayloadIResetPasswordRequest;
}

export interface UsersUpdateOrderChangePolicyRequest {
    usersPayloadIUpdateOrderChangePolicyRequest: UsersPayloadIUpdateOrderChangePolicyRequest;
}

export interface UsersUpdatePreferencesRequest {
    usersPayloadIUpdatePreferencesRequest: UsersPayloadIUpdatePreferencesRequest;
}

export interface UsersUserSetupRequest {
    usersPayloadIUserSetupRequest: UsersPayloadIUserSetupRequest;
}

/**
 *
 */
export class AuthApi extends runtime.BaseAPI {

    /**
     * Creates request options for authenticateUser without sending the request
     */
    async authenticateUserRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/user/authenticate`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Authenticate
     */
    async authenticateUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersResponseAuthResponse>> {
        const requestOptions = await this.authenticateUserRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Authenticate
     */
    async authenticateUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersResponseAuthResponse> {
        const response = await this.authenticateUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for forgotPassword without sending the request
     */
    async forgotPasswordRequestOpts(requestParameters: ForgotPasswordRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['usersPayloadIForgotPasswordRequest'] == null) {
            throw new runtime.RequiredError(
                'usersPayloadIForgotPasswordRequest',
                'Required parameter "usersPayloadIForgotPasswordRequest" was null or undefined when calling forgotPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/user/forgot-password`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['usersPayloadIForgotPasswordRequest'],
        };
    }

    /**
     * Forgot Password
     */
    async forgotPasswordRaw(requestParameters: ForgotPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersResponseForgotPasswordResponse>> {
        const requestOptions = await this.forgotPasswordRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Forgot Password
     */
    async forgotPassword(requestParameters: ForgotPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersResponseForgotPasswordResponse> {
        const response = await this.forgotPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for loginUser without sending the request
     */
    async loginUserRequestOpts(requestParameters: LoginUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['usersPayloadILoginRequest'] == null) {
            throw new runtime.RequiredError(
                'usersPayloadILoginRequest',
                'Required parameter "usersPayloadILoginRequest" was null or undefined when calling loginUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/user/login`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['usersPayloadILoginRequest'],
        };
    }

    /**
     * Login
     */
    async loginUserRaw(requestParameters: LoginUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersResponseLoginResponse>> {
        const requestOptions = await this.loginUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Login
     */
    async loginUser(requestParameters: LoginUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersResponseLoginResponse> {
        const response = await this.loginUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for logoutUser without sending the request
     */
    async logoutUserRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/user/logout`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Logout
     */
    async logoutUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.logoutUserRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Logout
     */
    async logoutUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.logoutUserRaw(initOverrides);
    }

    /**
     * Creates request options for resendConfirmation without sending the request
     */
    async resendConfirmationRequestOpts(requestParameters: ResendConfirmationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['usersPayloadIResendConfirmationRequest'] == null) {
            throw new runtime.RequiredError(
                'usersPayloadIResendConfirmationRequest',
                'Required parameter "usersPayloadIResendConfirmationRequest" was null or undefined when calling resendConfirmation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/user/resend-confirmation`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['usersPayloadIResendConfirmationRequest'],
        };
    }

    /**
     * Resend Confirmation
     */
    async resendConfirmationRaw(requestParameters: ResendConfirmationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersResponseResendConfirmationResponse>> {
        const requestOptions = await this.resendConfirmationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Resend Confirmation
     */
    async resendConfirmation(requestParameters: ResendConfirmationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersResponseResendConfirmationResponse> {
        const response = await this.resendConfirmationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersConfirmEmail without sending the request
     */
    async usersConfirmEmailRequestOpts(requestParameters: UsersConfirmEmailRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling usersConfirmEmail().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/user/confirm-email`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Confirm Email
     */
    async usersConfirmEmailRaw(requestParameters: UsersConfirmEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersResponseConfirmEmailResponse>> {
        const requestOptions = await this.usersConfirmEmailRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Confirm Email
     */
    async usersConfirmEmail(requestParameters: UsersConfirmEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersResponseConfirmEmailResponse> {
        const response = await this.usersConfirmEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersGetOrderChangePolicy without sending the request
     */
    async usersGetOrderChangePolicyRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/user/order-change-policy`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Order Change Policy
     */
    async usersGetOrderChangePolicyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersResponseGetOrderChangePolicyResponse>> {
        const requestOptions = await this.usersGetOrderChangePolicyRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Order Change Policy
     */
    async usersGetOrderChangePolicy(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersResponseGetOrderChangePolicyResponse> {
        const response = await this.usersGetOrderChangePolicyRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersRegister without sending the request
     */
    async usersRegisterRequestOpts(requestParameters: UsersRegisterRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['usersPayloadIRegisterRequest'] == null) {
            throw new runtime.RequiredError(
                'usersPayloadIRegisterRequest',
                'Required parameter "usersPayloadIRegisterRequest" was null or undefined when calling usersRegister().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/user/register`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['usersPayloadIRegisterRequest'],
        };
    }

    /**
     * Register
     */
    async usersRegisterRaw(requestParameters: UsersRegisterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersResponseRegisterResponse>> {
        const requestOptions = await this.usersRegisterRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Register
     */
    async usersRegister(requestParameters: UsersRegisterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersResponseRegisterResponse> {
        const response = await this.usersRegisterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersResetPassword without sending the request
     */
    async usersResetPasswordRequestOpts(requestParameters: UsersResetPasswordRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['usersPayloadIResetPasswordRequest'] == null) {
            throw new runtime.RequiredError(
                'usersPayloadIResetPasswordRequest',
                'Required parameter "usersPayloadIResetPasswordRequest" was null or undefined when calling usersResetPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/user/reset-password`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['usersPayloadIResetPasswordRequest'],
        };
    }

    /**
     * Reset Password
     */
    async usersResetPasswordRaw(requestParameters: UsersResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersResponseResetPasswordResponse>> {
        const requestOptions = await this.usersResetPasswordRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Reset Password
     */
    async usersResetPassword(requestParameters: UsersResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersResponseResetPasswordResponse> {
        const response = await this.usersResetPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersUpdateOrderChangePolicy without sending the request
     */
    async usersUpdateOrderChangePolicyRequestOpts(requestParameters: UsersUpdateOrderChangePolicyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['usersPayloadIUpdateOrderChangePolicyRequest'] == null) {
            throw new runtime.RequiredError(
                'usersPayloadIUpdateOrderChangePolicyRequest',
                'Required parameter "usersPayloadIUpdateOrderChangePolicyRequest" was null or undefined when calling usersUpdateOrderChangePolicy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/user/order-change-policy`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['usersPayloadIUpdateOrderChangePolicyRequest'],
        };
    }

    /**
     * Update Order Change Policy
     */
    async usersUpdateOrderChangePolicyRaw(requestParameters: UsersUpdateOrderChangePolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersResponseUpdateOrderChangePolicyResponse>> {
        const requestOptions = await this.usersUpdateOrderChangePolicyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update Order Change Policy
     */
    async usersUpdateOrderChangePolicy(requestParameters: UsersUpdateOrderChangePolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersResponseUpdateOrderChangePolicyResponse> {
        const response = await this.usersUpdateOrderChangePolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersUpdatePreferences without sending the request
     */
    async usersUpdatePreferencesRequestOpts(requestParameters: UsersUpdatePreferencesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['usersPayloadIUpdatePreferencesRequest'] == null) {
            throw new runtime.RequiredError(
                'usersPayloadIUpdatePreferencesRequest',
                'Required parameter "usersPayloadIUpdatePreferencesRequest" was null or undefined when calling usersUpdatePreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/user/preferences`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['usersPayloadIUpdatePreferencesRequest'],
        };
    }

    /**
     * Update Preferences
     */
    async usersUpdatePreferencesRaw(requestParameters: UsersUpdatePreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersResponseUpdatePreferencesResponse>> {
        const requestOptions = await this.usersUpdatePreferencesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update Preferences
     */
    async usersUpdatePreferences(requestParameters: UsersUpdatePreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersResponseUpdatePreferencesResponse> {
        const response = await this.usersUpdatePreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersUserSetup without sending the request
     */
    async usersUserSetupRequestOpts(requestParameters: UsersUserSetupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['usersPayloadIUserSetupRequest'] == null) {
            throw new runtime.RequiredError(
                'usersPayloadIUserSetupRequest',
                'Required parameter "usersPayloadIUserSetupRequest" was null or undefined when calling usersUserSetup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/user/user-setup`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['usersPayloadIUserSetupRequest'],
        };
    }

    /**
     * User Setup
     */
    async usersUserSetupRaw(requestParameters: UsersUserSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsersResponseUserSetupResponse>> {
        const requestOptions = await this.usersUserSetupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * User Setup
     */
    async usersUserSetup(requestParameters: UsersUserSetupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsersResponseUserSetupResponse> {
        const response = await this.usersUserSetupRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
